import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_ADMIN_PLAYERS = Symbol('admin-players');

// Players list
export const ADMIN_PLAYERS_ADDITIONAL_ROUTE_NAME = Symbol('admin.players.additional');
export const ADMIN_PLAYERS_LIST_ROUTE_NAME = Symbol('admin.players.additional.list');

export const PLAYERS_LIST_QUERY_KEY = 'players-list';
export const PLAYERS_LIST_API_URL = 'admin/observing_of_daily_statistics_players';

export const DOWNLOAD_PLAYERS_REPORT_API_URL = 'admin/observing_of_daily_statistics_players/download_list';
export const DOWNLOAD_PLAYERS_REPORT_MUTATION_KEY = 'download-players-report';

export const PLAYERS_PERMISSIONS = {
  PLAYERS_SHOW: new Permission(
    PermissionsList.admin.OBSERVINGOFDAILYSTATISTICSPLAYERS_SHOW,
  ),
  DOWNLOAD_PLAYERS_LIST: new Permission(
    PermissionsList.admin.OBSERVINGOFDAILYSTATISTICSPLAYERS_DOWNLOAD_LIST,
  ),
};
